// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js","989":"component---src-templates-blog-post-js"}[chunkId] || chunkId) + "-" + {"678":"c4cf2595c313fe297531","883":"43f7dcd5c22b9d8becbb","954":"e3145a47e6a60181e8b9","989":"5dabb8b35f840791a033"}[chunkId] + ".js";
};